<template>
    <div v-if="user" class="comment-form">
        <form class="form-horizontal inline-form inline-form-expanded" @submit.prevent="onCommentSubmit($event)">
            <avatar :avatar="user.avatar" class="avatar"></avatar>
            <!--<input type="text" id="message" ref="commentMessageField" name="message" class="message"-->
                   <!--v-model="message" placeholder="Ieraksti komentāru..." />-->
            <textarea id="message" ref="commentMessageField" name="message" class="message" v-model="message" placeholder="Ieraksti komentāru..." rows="1"></textarea>
            <button type="submit" class="button secondary hollow">Sūtīt</button>
        </form>
    </div>
</template>

<script>
    import Avatar from '../Avatar'
    import comments from '../../api/comments'
    import { mapGetters } from 'vuex'
    import autosize from 'autosize'

    export default {

        name: 'comment-form',

        props: {
            materialId: {
                type: Number,
                required: true,
            },
            replyTo: {
                type: Number,
                required: false,
            }
        },

        data() {
            return {
                message: null,
            }
        },

        mounted() {
            autosize(this.$refs.commentMessageField);
        },

        beforeDestroy() {
            autosize.destroy(this.$refs.commentMessageField);
        },

        methods: {
            /**
             * Comment form submit handler.
             */
            onCommentSubmit(event) {
                if (this.message === null || this.message === '') {
                    return;
                }

                comments.create(this.materialId, { message: this.message, replyTo: this.replyTo })
                    .then(response => {
                        this.message = null;
                        autosize.update(this.$refs.commentMessageField);
                        this.$emit('commented', response.data);
                    });
            }
        },

        computed: {

            ...mapGetters(['user'])

        },

        components: {Avatar}
    }
</script>

<style lang="scss" scoped>
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .comment-form {
        position: relative;
        font-size: rem-calc(14px);
        margin: 1rem 0;
        line-height: 1;

        .avatar {
            width: 35px;
            height: 35px;
            margin-right: 15px;
        }

        textarea.message {
            height: 34.5px;
            min-height: unset;
        }

        .button {
            margin-left: 15px;
        }
    }

    .inline-form {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        width: 100%;

        .message {
            flex: 1;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/comments/CommentForm.vue